/**
 * Category → emoji mapping (word-order-independent, partial match).
 *
 * Shared by the count overview template cards (CountInterface.jsx) and the
 * template-offer success preview (TemplateOfferPrompt.jsx) so the same
 * category shows the same icon everywhere. The template-type fallbacks match
 * the overview's templateEmojiFor: ordering templates fall back to a truck,
 * end-of-period templates to a basket.
 */

export const ORDER_TEMPLATE_ICON = '🚚';
export const EOP_TEMPLATE_ICON = '🧺';

export const getCategoryIcon = (cat) => {
  const c = (cat || '').toLowerCase().replace(/[&\-_\/]/g, ' ');
  const has = (...words) => words.some(w => c.includes(w));
  if (has('seafood', 'fish', 'shellfish', 'shrimp', 'lobster', 'crab', 'salmon', 'tuna', 'cod', 'oyster', 'clam', 'mussel', 'sushi', 'halibut')) return '🐟';
  if (has('wine', 'champagne', 'prosecco', 'sparkling', 'rose', 'merlot', 'cabernet', 'chardonnay', 'pinot', 'sauvignon')) return '🍷';
  if (has('liquor', 'spirit', 'whiskey', 'whisky', 'vodka', 'gin', 'rum', 'tequila', 'bourbon', 'scotch', 'brandy', 'cognac', 'mezcal', 'aperitif', 'cordial', 'bar', 'garnish', 'glassware', 'cocktail', 'mixer', 'mixes')) return '🍸';
  if (has('beer', 'ale', 'lager', 'draft', 'draught', 'brew', 'cider', 'stout', 'ipa')) return '🍺';
  if (has('meat', 'beef', 'steak', 'pork', 'chicken', 'poultry', 'lamb', 'veal', 'burger', 'sausage', 'deli', 'charcuterie', 'protein')) return '🥩';
  if (has('dairy', 'milk', 'cream', 'cheese', 'butter', 'yogurt', 'egg')) return '🥛';
  if (has('frozen', 'ice cream', 'gelato', 'sorbet', 'freeze')) return '🍦';
  if (has('produce', 'vegetable', 'fruit', 'salad', 'herb', 'fresh', 'greens', 'tomato', 'lettuce')) return '🥬';
  if (has('bakery', 'bread', 'pastry', 'baked', 'cake', 'roll', 'muffin', 'bagel', 'croissant')) return '🍞';
  if (has('beverage', 'drink', 'soda', 'coffee', 'tea', 'juice', 'water', 'non alc', 'nonalc', 'soft drink', 'mocktail', 'smoothie', 'energy')) return '🥤';
  if (has('dessert', 'sweet', 'candy', 'chocolate', 'confection', 'gelato')) return '🍰';
  if (has('paper', 'packaging', 'napkin', 'tissue', 'towel', 'wrap', 'foil', 'to go', 'takeout', 'disposable', 'goods')) return '🧻';
  if (has('cleaning', 'chemical', 'janitorial', 'sanitation', 'sanitizer', 'detergent', 'soap', 'cleaner', 'supplies')) return '🧹';
  if (has('dry', 'pantry', 'canned', 'grain', 'pasta', 'rice', 'flour', 'oil', 'vinegar', 'condiment', 'sauce', 'spice', 'seasoning')) return '📦';
  if (has('prepared', 'prep', 'ready', 'made')) return '🥘';
  if (has('food', 'grocery', 'ingredient', 'general', 'misc')) return '🍽️';
  return null;
};
